module.exports = __webpack_public_path__ + "f37ad5f496466bd2acf4ca52abbf7b90.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-72.cur
// module id = 474
// module chunks = 0